import { useMemo } from 'react';
/**
 * Obtem o texto do disclaimer. Só é utilizado se o 'disclaimer' na preference_whitelabel estiver cadastrado
 * OBS: Se houver disclaimer cadastrado na carteiraList, utiliza no lugar do disclaimer da preference_whitelabel
 *
 * @param carteira Nome da carteira
 * @param carteiraList Lista com todas as carteiras
 * @param preferenceCustomizacao Lista de customizacao do cliente
 * @returns Texto do disclaimer
 */
export function useDisclaimer(carteira, carteiraList, preferenceCustomizacao) {
    const disclaimer = useMemo(() => {
        var _a, _b;
        let disclaimerLocal = (_a = preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.disclaimer) !== null && _a !== void 0 ? _a : null;
        if (disclaimerLocal) {
            const disclaimerCarteiraList = (_b = carteiraList.find((item) => item.nome_portfolio.toUpperCase() === (carteira === null || carteira === void 0 ? void 0 : carteira.toUpperCase()))) === null || _b === void 0 ? void 0 : _b.disclaimer;
            // Se houver disclaimer na carteiraList, utiliza no lugar do disclaimer da preference_whitelabel
            if (disclaimerCarteiraList) {
                disclaimerLocal = disclaimerCarteiraList;
            }
        }
        return disclaimerLocal;
    }, [carteira, carteiraList, preferenceCustomizacao]);
    return disclaimer;
}
export default useDisclaimer;
